/**
 * Client-side feature flags driven by VITE_* env vars.
 *
 * VITE_SHOW_ONBOARDING — set to "true" to expose the brand onboarding page
 * (/brand/onboarding), the "Finish setting up your brand" dashboard card and
 * the incomplete-onboarding redirect. Anything else (including unset) hides
 * all of it and makes /brand/onboarding render the 404 page.
 */
export const SHOW_ONBOARDING = import.meta.env.VITE_SHOW_ONBOARDING === "true";

// TikTok Shop visibility is per brand and server-driven: see
// src/hooks/useTikTokAccess.ts (there is no build-time flag any more).

/**
 * VITE_ASSISTANT_ENABLED — "true" shows the brand assistant panel and talks
 * to the real backend. VITE_ASSISTANT_STUB — "true" shows the panel and
 * replays the canned streams in src/components/assistant/fixtures with no
 * network, for building the panel and demos before the backend exists.
 * Both unset: no assistant surface renders.
 */
export const ASSISTANT_ENABLED = import.meta.env.VITE_ASSISTANT_ENABLED === "true";
export const ASSISTANT_STUB = import.meta.env.VITE_ASSISTANT_STUB === "true";
